import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import StrategicDoctor from 'app/containers/HumanResources/StrategicDoctor'

const StrategicDoctorPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.strategic_doctor)}</PageTitle>
      <StrategicDoctor />
    </>
  )
}
const StrategicDoctorPage = memo(StrategicDoctorPageCpn, isEqual)

export default StrategicDoctorPage
